export default __webpack_public_path__ + "static/media/Pizza.01bfa164.jpg";